import styled from "styled-components"
import { Link } from "react-router-dom"

export const Title = styled.div`
   width: 100%;
   border-radius: 5px;
   position: absolute;
   top: 0;
   z-index: 3;
   display: none;
   transition: all 0.5s ease;
   align-items: center;
   justify-content: center;
   color: var(--secondary);
   font-size: var(--fontL);
   font-weight: 600;
`

export const Colors = styled.div`
   padding: 10px;
   width: 100%;
   border-radius: 5px;
   position: absolute;
   bottom: 0;
   z-index: 3;
   display: none;
   transition: all 0.5s ease;
   display: none;
   align-items: center;
   justify-content: right;
   color: var(--secondary);
   font-size: var(--fontM);
`

export const Price = styled.div`
   padding: 10px;
   width: 100%;
   border-radius: 5px;
   position: absolute;
   bottom: 0;
   z-index: 3;
   display: none;
   transition: all 0.5s ease;
   display: none;
   align-items: center;
   justify-content: left;
   color: var(--secondary);
   font-size: var(--fontM);
`

export const StyledLink = styled(Link)`
   display: none;
   width: 100%;
   height: 100%;
   border-radius: 5px;
   position: absolute;
   top: 0;
   left: 0;
   background-color: rgba(0, 0, 0, 0.6);
   z-index: 10;
   opacity: 0;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   transition: all 0.5s ease;
`

export const Icon = styled.div`
   display: none;
   width: 60px;
   height: 60px;
   border-radius: 50%;
   background-color: var(--medGrey);
   color: var(--primary);
   align-items: center;
   justify-content: center;
   margin: 10px;
   cursor: pointer;
   z-index: 20;
`

export const MobileIcon = styled.div`
   display: none;
   z-index: 100;
`

export const Container = styled.div`
   background-color: var(--medGrey);
   position: relative;
   width: 100%;
   height: 350px;
   border-radius: 5px;
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0px 0px;
   z-index: 0;

   @media (hover: none) {
      &:focus ${StyledLink} {
         display: flex;
         opacity: 1;
      }

      &:focus ${Title} {
         display: flex;
      }

      &:focus ${Colors} {
         display: flex;
      }

      &:focus ${Price} {
         display: flex;
      }

      &:focus ${Icon} {
         display: flex;
      }

      &:focus ${MobileIcon} {
         display: flex;
      }
   }

   @media (hover: hover) {
      &:hover ${StyledLink} {
         display: flex;
         opacity: 1;
      }

      &:hover ${Title} {
         display: flex;
      }

      &:hover ${Colors} {
         display: flex;
      }

      &:hover ${Price} {
         display: flex;
      }
   }
`

export const Image = styled.img`
   height: 100%;
   width: 100%;
   border-radius: 5px;
   object-fit: cover;
   z-index: 2;
`
